import React from 'react';
import FormAddEditPostTag from '../../../components/blog/tags/FormAddEditPostTag';
import WrapperSection from '../../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../../components/global/GlobalBreadcrumbs';

const CreatePostTag = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPostTag />
        </WrapperSection>
    );
};

export default CreatePostTag;
